import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const propertyCarouselDefaultVariants = {}
const propertyCarouselCompoundVariants = []

const propertyCarouselSlotNames = [
  [
    "carouselRoot",
    "property-carousel__carouselRoot"
  ],
  [
    "carouselFadeEdge",
    "property-carousel__carouselFadeEdge"
  ],
  [
    "carouselTrack",
    "property-carousel__carouselTrack"
  ],
  [
    "carouselTrackFadePadding",
    "property-carousel__carouselTrackFadePadding"
  ],
  [
    "carouselItem",
    "property-carousel__carouselItem"
  ],
  [
    "carouselHeader",
    "property-carousel__carouselHeader"
  ],
  [
    "carouselTitle",
    "property-carousel__carouselTitle"
  ],
  [
    "carouselControls",
    "property-carousel__carouselControls"
  ],
  [
    "carouselControlButton",
    "property-carousel__carouselControlButton"
  ],
  [
    "carouselSkipLinks",
    "property-carousel__carouselSkipLinks"
  ],
  [
    "carouselSkipLink",
    "property-carousel__carouselSkipLink"
  ],
  [
    "indicatorsContainer",
    "property-carousel__indicatorsContainer"
  ],
  [
    "dotBase",
    "property-carousel__dotBase"
  ],
  [
    "dotInactive",
    "property-carousel__dotInactive"
  ],
  [
    "dotActive",
    "property-carousel__dotActive"
  ],
  [
    "dotInactiveLight",
    "property-carousel__dotInactiveLight"
  ],
  [
    "dotActiveLight",
    "property-carousel__dotActiveLight"
  ]
]
const propertyCarouselSlotFns = /* @__PURE__ */ propertyCarouselSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, propertyCarouselDefaultVariants, getSlotCompoundVariant(propertyCarouselCompoundVariants, slotName))])

const propertyCarouselFn = memo((props = {}) => {
  return Object.fromEntries(propertyCarouselSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const propertyCarouselVariantKeys = [
  "gap",
  "snapAlign",
  "scrollBehavior",
  "level"
]
const getVariantProps = (variants) => ({ ...propertyCarouselDefaultVariants, ...compact(variants) })

export const propertyCarousel = /* @__PURE__ */ Object.assign(propertyCarouselFn, {
  __recipe__: false,
  __name__: 'propertyCarousel',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: propertyCarouselVariantKeys,
  variantMap: {
  "gap": [
    "xs",
    "sm",
    "md",
    "lg"
  ],
  "snapAlign": [
    "start",
    "center",
    "end",
    "none"
  ],
  "scrollBehavior": [
    "auto",
    "smooth"
  ],
  "level": [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, propertyCarouselVariantKeys)
  },
  getVariantProps
})